import { useEffect, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, UIPermission, useGetCrumbs } from "../../../../../features/ui"
import { useNavigate } from "react-router-dom"
import { CreditPaymentForm } from "./creditPaymentForm"
import { useCreditPaymentHooks } from "../../../hooks/creditPaymentHooks"
import { CustomerDebtData } from "../../../hooks/types"
import { Customer, useCustomerLoaders } from "../../../../sales"
import { useSystemStateHooks } from "../../../../system"

export const CreditPaymentFormLoader = () => {
    const { dataTypeId } = useRoutesHooks().parseUrl()
    const customerId = dataTypeId!

    const [ready, setReady] = useState(false)
    const [key, setKey] = useState(0)
    const [customer, setCustomer] = useState<O<Customer>>()
    const [debtData, setDebtData] = useState<CustomerDebtData>()

    const { userHasPermission } = useSystemStateHooks()
    const { getCustomerDebtData } = useCreditPaymentHooks()
    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const customerLoaders = useCustomerLoaders()

    const load = async () => {
        if (!userHasPermission(UIPermission.CREATE_CREDIT_PAYMENTS)) {
            navigate(getRoutePath(RoutePath.CREDIT_ACCOUNTS))
        } else  {
            const { loadCustomer } = customerLoaders()
            const loadedCustomer = await loadCustomer(customerId, true)
            setCustomer(loadedCustomer)
            const loadedDebtData = await getCustomerDebtData(customerId, true)
            setDebtData(loadedDebtData)
        }
    }

    useEffect(() => {
        setReady(false)
        load().then(() => setReady(true))
    }, [key])

    const title = 'Nuevo Cobro de Cuenta Corriente'
    const crumbs = useGetCrumbs(
        'Cuentas Corrientes',
        RoutePath.CREDIT_ACCOUNTS,
        undefined,
        undefined,
        'Nuevo Cobro'
    )

    const reload = () => setKey(key + 1)

    return (
        <>
            <PanelLoader
                title={title}
                crumbs={crumbs}
                ready={ready}
            >
                <CreditPaymentForm
                    key={key}
                    reload={reload}
                    customer={customer!}
                    debtData={debtData!}
                />
            </PanelLoader>
        </>
    )
}
